import type { IconSvgObject } from './types';

const Parabola01Icon: IconSvgObject = [
  ["path", { d: "M21 3C21 11.2843 16.9706 18 12 18C7.02944 18 3 11.2843 3 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 21H4.5M15.5 21H16.5M19.5 21H20.5M7.5 21H8.5M11.5 21H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Parabola01Icon;
